import { render, staticRenderFns } from "./DeliverableTypeIcon.vue?vue&type=template&id=4e20b2e8&"
import script from "./DeliverableTypeIcon.vue?vue&type=script&lang=js&"
export * from "./DeliverableTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableTypeIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports